"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGiveawayEntryCallback = void 0;
const giveaways_constants_1 = require("root/src/shared/giveaways/giveaways.constants");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const createGiveawayEntryCallbackPayloadSchema = {
    type: 'object',
    properties: {
        state: {
            type: 'string',
        },
        idToken: {
            type: 'string',
        },
    },
    additionalProperties: true,
};
/**
 * GET request callback
 */
exports.createGiveawayEntryCallback = {
    [giveaways_constants_1.giveawayEndpointIds.CREATE_GIVEAWAY_ENTRY_CALLBACK]: {
        endpointType: lenses_1.gatewayEndpointType,
        payloadSchema: createGiveawayEntryCallbackPayloadSchema,
    },
};
